/**
 * Alcohol Unit Calculator
 * Calculates alcohol units based on drink type, measure, and quantity
 */
const alcoholUnit = (function () {

    // Global variable to store alcohol unit data
    let jsonData = null;

    // Global variable to store calculator object
    const calcElement = document.getElementById('alcohol-unit-calc');

    /**
     * Initialize the calculator by loading data from page element
     */
    function initAlcoholCalculator() {
        // Get JSON data from data-json attribute on page
        if (calcElement) {
            try {
                jsonData = JSON.parse(calcElement.getAttribute('data-json'));
            } catch (error) {
                console.error('Error parsing JSON data from page:', error);
                // Fallback to empty object if parsing fails
                jsonData = {};
            }
        } else {
            console.warn('No element with data-json attribute found');
            jsonData = {};
        }
    }
    /**
     * Alcohol Unit Calculator Object
     * Handles all calculator functionality including form validation, 
     * drink calculations, and results display
     */
    const AlcoholCalculator = {
        activeDrinks: [],
        drinkIsInActiveDrinks: false,
        isPremium: false,
        selectedDrink: "",
        beersArray: [{
            name: 'Lager',
            type: "beer"
        }, {
            name: 'Cider',
            type: "beer"
        }, {
            name: 'Beer',
            type: 'beer'
        }],
        beersMeasureArray: [{
            name: 'Bottle (330ml)',
            measure: "bottle"
        }, {
            name: 'Can (440ml)',
            measure: "can"
        }, {
            name: 'Pint (568ml)',
            measure: "pint"
        }],
        winesArray: [{
            name: 'Red Wine',
            type: 'wine'
        }, {
            name: 'White Wine',
            type: 'wine'
        }, {
            name: 'Rose Wine',
            type: 'wine'
        }, {
            name: 'Champagne',
            type: 'wine'
        }, {
            name: 'Prosecco',
            type: 'wine'
        }],
        winesMeasureArray: [{
            name: 'Small glass (125ml)',
            measure: "small"
        }, {
            name: 'Standard glass (175ml)',
            measure: "standard"
        }, {
            name: 'Large glass (250ml)',
            measure: "large"
        }, {
            name: 'Bottle (750ml)',
            measure: "bottle"
        }],
        spiritsArray: [{
            name: 'Alcopops',
            type: 'alcopop'
        }, {
            name: 'Brandy',
            type: 'spirit'
        }, {
            name: 'Rum',
            type: 'spirit'
        }, {
            name: 'Vodka',
            type: 'spirit'
        }, {
            name: 'Whisky',
            type: 'spirit'
        }, {
            name: 'Gin',
            type: 'spirit'
        }, {
            name: 'Tequila',
            type: 'tequila-sambuca'
        }, {
            name: 'Sambuca',
            type: 'tequila-sambuca'
        }, {
            name: 'Sherry',
            type: 'sherry-port'
        }, {
            name: 'Port',
            type: 'sherry-port'
        }],
        spiritsMeasureArray: [{
            name: 'Small measure (25ml)',
            measure: "small"
        }, {
            name: 'Large measure (35ml)',
            measure: "large"
        }, {
            name: 'Small double measure (50ml)',
            measure: "smallDouble"
        }, {
            name: 'Large double measure (70ml)',
            measure: "largeDouble"
        }],
        drink: "",
        measure: "",
        drinkName: "",
        measureAmount: 0,

        numberInputStep(e) {
            e.preventDefault();
            const validationError = document.querySelector('.unit-count .field-validation-error');
            if (validationError !== null) validationError.remove();
            const _this = e.target;

            const input = _this.parentNode.querySelector('input[type=number]');

            let currentVal = +input.value;

            if (_this.classList.contains('plus')) {
                input.value = currentVal + 1;
            } else {
                if (currentVal === 0) return;
                input.value = currentVal - 1;
            }
        },

        /**
         * Progress to question 1 and populate drink selection dropdowns
         */
        progressQ1(e) {
            const q1Container = document.querySelector('.question--one');
            const q2Container = document.querySelector('.question--two');
            const formFooter = document.querySelector('.form-footer');
            q1Container.classList.add('display-none');
            q2Container.classList.remove('display-none');
            formFooter.classList.remove('display-none');

            this.populateSelects();
            AlcoholCalculator.updateProgressTracker();
        },

        /**
         * Populate drink selection dropdowns based on selected alcohol type
         */

        populateSelects() {
            this.selectedDrink = document.querySelector('input[name="alcohol-drunk"]:checked').value;
            let drinksArray;

            if (this.selectedDrink === "wines") {
                drinksArray = this.winesArray;
            } else if (this.selectedDrink === "beers") {
                drinksArray = this.beersArray;
            } else if (this.selectedDrink === "stouts") {
                drinksArray = [{
                    name: "Stout",
                    type: "stout"
                }];
            } else {
                drinksArray = this.spiritsArray;
            }

            this.addOptions(drinksArray, 'drink-type');
        },

        /**
         * Add options to select dropdown
         */

        addOptions(array, question) {
            let select;

            if (question === 'drink-type') {
                select = document.getElementById("drink-type");
            } else {
                select = document.getElementById("measure-unit");
            }

            if (!select || !array || !Array.isArray(array)) return;

            const defaultHtml = '<option value="" disabled selected>Select an option...</option>';
            select.innerHTML = defaultHtml;
            array.forEach(drink => {
                const option = document.createElement("option");
                option.text = drink.name;
                option.value = drink.name;
                if (drink.type) option.dataset.type = drink.type;
                if (drink.measure) option.dataset.measure = drink.measure;
                select.add(option);
            });
        },

        updateProgressTracker() {
            let direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "forward";
            const activeStep = document.querySelector('.progress-tracker__bar .active');
            activeStep.classList.remove('active');
            const progress1 = document.getElementById('progress-1');
            const progress2 = document.getElementById('progress-2');
            const progress3 = document.getElementById('progress-3');
            const stepNum = document.getElementById('progress-tracker-stepNum');
            let stepNumVal = +stepNum.innerHTML;

            if (direction === "back") {
                stepNumVal = stepNumVal - 1;
            } else {
                stepNumVal = stepNumVal + 1;
            }

            switch (activeStep.id) {
                case "progress-1":
                    progress2.classList.add('active');
                    progress1.classList.add('completed');
                    break;

                case "progress-2":
                    if (direction === "back") {
                        progress1.classList.remove('completed');
                        progress1.classList.add('active');
                    } else {
                        progress2.classList.add('completed');
                        progress3.classList.add('active');
                    }

                    break;

                default:
            }

            stepNum.innerHTML = stepNumVal;
        },

        resetProgressTracker() {
            let lastStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            const progress1 = document.getElementById('progress-1');
            const stepNumEl = document.getElementById('progress-tracker-stepNum');

            if (lastStep) {
                progress1.classList.remove('active');
                progress1.classList.add('completed');
                document.getElementById('progress-2').classList.add('completed');
                document.getElementById('progress-3').classList.add('active');
                stepNumEl.innerHTML = "3";
            } else {
                document.querySelectorAll('.completed').forEach(step => step.classList.remove('completed'));
                document.querySelector('.active').classList.remove('active');
                progress1.classList.add('active');
                stepNumEl.innerHTML = "1";
            }
        },

        revealQuestion(question) {
            switch (question) {
                case "premium-strength":
                    document.getElementById('premium-strength').classList.remove('display-none');
                    break;

                case "measure":
                    document.querySelector('.measure-unit').classList.remove('display-none');
                    break;
            }
        },

        /**
         * Handle back button click from results to questions
         */
        backBtnOneClick() {
            document.querySelector('.calculator-question--container').classList.add('display-none');
            document.querySelector('.question--one').classList.add('display-none');
            document.querySelector('.form-footer').classList.add('display-none');
            document.querySelector('.calculator-results--container').classList.remove('display-none');
            AlcoholCalculator.resetProgressTracker(true);
        },

        /**
         * Handle back button click from question 2 to question 1
         */
        backBtnTwoClick() {
            const q1Container = document.querySelector('.question--one');
            const q2Container = document.querySelector('.question--two');
            const formFooter = document.querySelector('.form-footer');
            q1Container.classList.remove('display-none');
            q2Container.classList.add('display-none');
            formFooter.classList.add('display-none');

            AlcoholCalculator.updateProgressTracker('back');
            AlcoholCalculator.reset();
        },

        handleValidation() {
            // Clear all existing errors first
            document.querySelectorAll('.field-validation-error').forEach(error => error.remove());

            // Selects
            document.querySelectorAll('select').forEach(select => {
                if (select.value === "" && !select.parentNode.classList.contains('display-none')) {
                    let message;
                    let label;

                    if (select.id === "drink-type") {
                        message = "Please select a drink type";
                        label = document.querySelector('label[for="drink-type"]');
                    } else if (select.id === "measure-unit") {
                        message = "Please select the measure";
                        label = document.querySelector('label[for="measure-unit"]');
                    }

                    if (label && message) {
                        const errorDiv = this.createErrorMessage(message);
                        label.parentNode.insertBefore(errorDiv, label.nextSibling);
                    }
                }
            });

            // Premium strength radios
            const premiumStrengthQ = document.getElementById('premium-strength');
            if (premiumStrengthQ && !premiumStrengthQ.classList.contains('display-none')) {
                const checkedRadio = premiumStrengthQ.querySelector('input[type="radio"]:checked');
                if (checkedRadio === null) {
                    const label = document.querySelector('#premium-strength legend');
                    if (label) {
                        const errorDiv = this.createErrorMessage("Please select if the drink was of premium strength");
                        label.parentNode.insertBefore(errorDiv, label.nextSibling);
                    }
                }
            }

            // Number stepper
            const unitQ = document.querySelector('.unit-count');
            const stepper = document.getElementById('measure-amount');

            if (stepper && unitQ && stepper.value <= 0 && !unitQ.classList.contains('display-none')) {
                const label = document.querySelector('label[for="measure-amount"]');
                if (label) {
                    const errorDiv = this.createErrorMessage("Please select how many of these measures you drank");
                    label.parentNode.insertBefore(errorDiv, label.nextSibling);
                }
            }
        },

        populateQ4LabelText() {
            const labelText = document.getElementById('measure-amount-label');
            const measureSelect = document.getElementById('measure-unit');

            if (!labelText || !measureSelect || !measureSelect.value) return;

            const selectVal = measureSelect.value;
            let textToInput = selectVal.substring(0, selectVal.indexOf('(')).trimEnd();

            if (textToInput.includes('glass')) {
                textToInput = "".concat(textToInput, "es");
            } else if (selectVal === "275ml") {
                textToInput = "bottles";
            } else if (selectVal === "50ml") {
                textToInput = "measures";
            } else {
                textToInput = "".concat(textToInput, "s");
            }

            labelText.innerHTML = textToInput.toLowerCase();
        },

        getDisplayMeasureText() {
            let measureAmount = document.getElementById('measure-unit').value;

            if (measureAmount.includes('(')) {
                measureAmount = measureAmount.substring(measureAmount.indexOf('('));
            } else {
                measureAmount = "(".concat(measureAmount, ")");
            }

            return measureAmount;
        },

        pushToDrinksArray(drinkName, measure, units) {
            const id = Math.floor(Math.random() * 1000000);

            if (this.activeDrinks.length === 0) {
                this.activeDrinks.push({
                    name: drinkName,
                    measure: measure,
                    amount: +this.measureAmount,
                    units: +units,
                    id: id
                });
                return;
            }

            const existingDrink = this.activeDrinks.find(drink => drink.name === drinkName && drink.measure === measure);

            if (existingDrink === undefined) {
                this.drinkIsInActiveDrinks = false;
                this.activeDrinks.push({
                    name: drinkName,
                    measure: measure,
                    amount: +this.measureAmount,
                    units: +units,
                    id: id
                });
            } else {
                this.drinkIsInActiveDrinks = true;
                existingDrink.amount = existingDrink.amount + +this.measureAmount;
                existingDrink.units = existingDrink.units + +units;
            }
        },

        createErrorMessage(message) {
            const fieldValDiv = document.createElement('div');
            const innerDiv = document.createElement('div');
            fieldValDiv.classList.add('field-validation-error');
            innerDiv.classList.add('error-message');
            innerDiv.innerHTML = message;
            fieldValDiv.appendChild(innerDiv);
            return fieldValDiv;
        },

        handleFormSubmit(e) {
            e.preventDefault();
            this.handleValidation();
            const errors = document.querySelectorAll('.calculator--container .field-validation-error');
            if (errors.length > 0) return;
            document.getElementById('backOne').classList.remove('display-none');
            const questionContainer = document.querySelector('.calculator-question--container');
            const formFooter = document.querySelector('.form-footer');
            [questionContainer, formFooter].forEach(el => el.classList.add('display-none'));
            this.revealResults();
        },

        renderResults() {
            const tableBody = document.querySelector('tbody');
            const theadHtml = "\n            <tr>\n                <th><div>Type</div></th>\n                <th><div>Units</div></th>\n            </tr>\n        ";
            const totalUnitsEl = document.getElementById('total-units');
            const overUnderSpanEl = document.getElementById('unitsOverOrUnder');
            const totalUnits = this.activeDrinks.reduce((accumulator, drink) => {
                return accumulator + drink.units;
            }, 0);

            if (totalUnits === 14) {
                overUnderSpanEl.innerHTML = "the same amount as";
            } else if (totalUnits > 14) {
                overUnderSpanEl.innerHTML = "".concat((totalUnits - 14).toFixed(1), " units over");
            } else {
                overUnderSpanEl.innerHTML = "".concat((14 - totalUnits).toFixed(1), " units under");
            }

            tableBody.innerHTML = theadHtml;
            this.activeDrinks.map(drink => {
                let drinkName;
                drink.amount > 1 ? drinkName = "".concat(drink.name, " ").concat(drink.measure, " x ").concat(drink.amount) : drinkName = "".concat(drink.name, " ").concat(drink.measure); // Create new table row

                const tableRowHtml = "\n                <tr data-id=\"".concat(drink.id, "\">\n                    <td>\n                        <div>").concat(drinkName, "</div>\n                    </td>\n                    <td>\n                        <div>").concat(drink.units, "</div>\n                    </td>\n                </tr>\n                <tr>\n                    <td>\n                        <button class=\"btn btn--link btn--remove\">\n                            Remove\n                        </button>\n                    </td>\n                </tr>\n            ");
                tableBody.innerHTML += tableRowHtml;
            });

            if (totalUnits === 0) {
                totalUnitsEl.innerHTML = "0 units";
            } else {
                totalUnitsEl.innerHTML = "".concat(totalUnits.toFixed(1), " units");
            }
        },

        revealResults() {
            this.drinkName = document.getElementById('drink-type').value;
            this.measureAmount = document.getElementById('measure-amount').value;
            const displayMeasureText = this.getDisplayMeasureText();
            if (this.drink === "beer" && this.isPremium) this.drink = "beerPremium";
            const units = (jsonData[this.drink][this.measure] * this.measureAmount).toFixed(2);
            const resultsContainer = document.querySelector('.calculator-results--container');
            let drinkDisplayText = this.measureAmount > 1 ? "".concat(this.drinkName, " ").concat(displayMeasureText, " x ").concat(this.measureAmount) : "".concat(this.drinkName, " ").concat(displayMeasureText);
            let drinkName = this.drinkName;

            if (this.isPremium) {
                drinkDisplayText = "Premium ".concat(drinkDisplayText);
                drinkName = "Premium ".concat(this.drinkName);
            }

            this.pushToDrinksArray(drinkName, displayMeasureText, units);
            this.renderResults();
            AlcoholCalculator.updateProgressTracker();
            resultsContainer.classList.remove('display-none');
        },

        /**
         * Add another drink - reset form and return to question 1
         */
        addAnotherDrink() {
            AlcoholCalculator.reset();
            AlcoholCalculator.resetProgressTracker();

            document.querySelector('.calculator-results--container').classList.add('display-none');
            document.querySelector('.question--two').classList.add('display-none');
            document.querySelector('.calculator-question--container').classList.remove('display-none');
            document.querySelector('.question--one').classList.remove('display-none');
        },

        /**
         * Remove a drink from the results
         */

        removeDrink(e) {
            if (!e.target.classList.contains('btn--remove')) return;
            const drinkId = e.target.closest('tr').previousElementSibling.dataset.id;
            this.activeDrinks = this.activeDrinks.filter(drink => {
                return drink.id !== +drinkId;
            });
            this.renderResults();
        },

        reset() {
            // Clear all Q1 radio buttons
            document.querySelectorAll('#q1 input[type="radio"]').forEach(radio => {
                radio.checked = false;
            });

            // Clear premium strength radios
            document.querySelectorAll('#premium-strength input[type="radio"]').forEach(radio => {
                radio.checked = false;
            });

            // Reset all select dropdowns
            document.querySelectorAll('select').forEach(select => {
                select.value = "";
                select.classList.remove('unselected');
            });

            // Reset measure amount input
            const measureCountInput = document.getElementById('measure-amount');
            if (measureCountInput) {
                measureCountInput.value = 0;
            }

            // Clear all validation errors
            document.querySelectorAll('.field-validation-error').forEach(error => error.remove());

            // Hide all conditional sections
            const premiumStrengthQ = document.getElementById('premium-strength');
            const mesaureUnitQ = document.querySelector('.measure-unit');
            const unitCountQ = document.querySelector('.unit-count');

            if (premiumStrengthQ) {
                premiumStrengthQ.classList.add('display-none');
            }

            if (mesaureUnitQ) {
                mesaureUnitQ.classList.add('display-none');
            }

            if (unitCountQ) {
                unitCountQ.classList.add('display-none');
            }

            // Reset object properties
            this.drink = "";
            this.measure = "";
            this.drinkName = "";
            this.measureAmount = 0;
            this.isPremium = false;
            this.selectedDrink = "";
            this.drinkIsInActiveDrinks = false;
        },

        /**
         * Full reset - clear all data and return to initial state
         */
        fullReset() {
            AlcoholCalculator.activeDrinks = [];
            AlcoholCalculator.reset();

            document.querySelector('.calculator-results--container').classList.add('display-none');
            document.querySelector('.calculator-question--container').classList.remove('display-none');
            document.querySelector('.question--two').classList.add('display-none');
            document.querySelector('.question--one').classList.remove('display-none');
            document.getElementById('backOne').classList.add('display-none');

            // Clear the results table
            const tableBody = document.querySelector('tbody');
            if (tableBody) {
                tableBody.innerHTML = '';
            }

            // Reset total units display
            const totalUnitsEl = document.getElementById('total-units');
            const overUnderSpanEl = document.getElementById('unitsOverOrUnder');
            if (totalUnitsEl) {
                totalUnitsEl.innerHTML = "0 units";
            }
            if (overUnderSpanEl) {
                overUnderSpanEl.innerHTML = "14.0 units under";
            }

            AlcoholCalculator.resetProgressTracker();
        }
    };
    /**
     * Initialize event listeners when DOM is ready
     */
    document.addEventListener('DOMContentLoaded', () => {
        // Initialize calculator with data from page
        initAlcoholCalculator();

        // Question event listeners
        // Q1: Drink type selection
        const q1Radios = document.querySelectorAll('#q1 input[type=radio]');
        for (let i = 0; i < q1Radios.length; i++) {
            q1Radios[i].addEventListener('click', e => AlcoholCalculator.progressQ1(e));
        }

        // Q2: Drink subtype selection
        const drinkTypeSelect = document.getElementById('drink-type');
        if (drinkTypeSelect) {
            drinkTypeSelect.addEventListener('change', e => {
                let measureArray;
                drinkTypeSelect.classList.remove('unselected');
                const validationError = document.querySelector('.drink-type .field-validation-error');
                if (validationError !== null) validationError.remove();

                const selectedOption = drinkTypeSelect.options[drinkTypeSelect.selectedIndex];
                if (!selectedOption || !selectedOption.dataset || !selectedOption.dataset.type) return;

                AlcoholCalculator.drink = selectedOption.dataset.type;
                const unitStepper = document.querySelector('.unit-count');
                const measureAmount = document.getElementById('measure-amount');
                const drinkSelected = drinkTypeSelect.value.toLowerCase();

                switch (AlcoholCalculator.drink) {
                    case "beer":
                        let drink;
                        let percent;

                        if (drinkSelected === "lager") {
                            drink = "Lager";
                            percent = "4.5%";
                        } else {
                            drink = "Ale";
                            percent = "4.2%";
                        }

                        const helptextDrink = document.getElementById('helptext-drink');
                        const helptextPercent = document.getElementById('helptext-percent');
                        if (helptextDrink) helptextDrink.textContent = drink;
                        if (helptextPercent) helptextPercent.textContent = percent;
                        measureArray = AlcoholCalculator.beersMeasureArray;
                        break;

                    case "stout":
                        measureArray = AlcoholCalculator.beersMeasureArray;
                        break;

                    case "wine":
                        measureArray = AlcoholCalculator.winesMeasureArray;
                        break;

                    case "spirit":
                        measureArray = AlcoholCalculator.spiritsMeasureArray;
                        if (unitStepper) unitStepper.classList.add('display-none');
                        if (measureAmount) measureAmount.value = 0;
                        break;

                    case "alcopop":
                        measureArray = [{
                            name: '275ml',
                            measure: "bottle"
                        }];
                        if (unitStepper) unitStepper.classList.add('display-none');
                        if (measureAmount) measureAmount.value = 0;
                        break;

                    case "tequila-sambuca":
                        measureArray = [{
                            name: 'Small measure (25ml)',
                            measure: "small"
                        }, {
                            name: 'Large measure (35ml)',
                            measure: "large"
                        }];
                        if (unitStepper) unitStepper.classList.add('display-none');
                        if (measureAmount) measureAmount.value = 0;
                        break;

                    case "sherry-port":
                        measureArray = [{
                            name: '50ml',
                            measure: "standard"
                        }];
                        if (unitStepper) unitStepper.classList.add('display-none');
                        if (measureAmount) measureAmount.value = 0;
                        break;
                }

                AlcoholCalculator.addOptions(measureArray, 'measure');

                if (AlcoholCalculator.drink === "beer" && (drinkSelected === "lager" || drinkSelected === "beer")) {
                    AlcoholCalculator.revealQuestion('premium-strength');
                } else {
                    const premiumStrength = document.getElementById('premium-strength');
                    if (premiumStrength) premiumStrength.classList.add('display-none');
                    AlcoholCalculator.revealQuestion('measure');
                }
            });
        }

        // Q2.5: Premium strength selection
        document.querySelectorAll('#premium-strength input[type="radio"]').forEach(radio => {
            radio.addEventListener('click', e => {
                const validationError = document.querySelector('#premium-strength .field-validation-error');
                if (validationError !== null) validationError.remove();

                AlcoholCalculator.revealQuestion('measure');
                AlcoholCalculator.isPremium = e.target.value === "true";
            });
        });

        // Q3: Measure selection
        const measureSelect = document.getElementById('measure-unit');
        if (measureSelect) {
            measureSelect.addEventListener('change', e => {
                const validationError = document.querySelector('.measure-unit .field-validation-error');
                if (validationError !== null) validationError.remove();
                measureSelect.classList.remove('unselected');

                AlcoholCalculator.populateQ4LabelText();

                const unitCountElement = document.querySelector('.unit-count');
                if (unitCountElement) {
                    unitCountElement.classList.remove('display-none');
                }

                // Safely get the selected option's measure data
                const selectedOption = e.target.options[e.target.selectedIndex];
                if (selectedOption && selectedOption.dataset && selectedOption.dataset.measure) {
                    AlcoholCalculator.measure = selectedOption.dataset.measure;
                } else {
                    console.warn('No measure data found on selected option'); // Debug warning
                }
            });
        }

        // Q4: Number steppers for quantity
        const steppers = document.querySelectorAll('.stepper');
        for (let i = 0; i < steppers.length; i++) {
            steppers[i].addEventListener('click', AlcoholCalculator.numberInputStep);
        }

        // Form submission
        document.querySelector('.calculator-question--container form').addEventListener('submit', e => AlcoholCalculator.handleFormSubmit(e));

        // Action buttons
        document.querySelector('.btn--add').addEventListener('click', AlcoholCalculator.addAnotherDrink);
        document.querySelector('.results-table').addEventListener('click', e => AlcoholCalculator.removeDrink(e));
        document.getElementById('reset').addEventListener('click', AlcoholCalculator.fullReset);

        // Back buttons
        const backBtnOne = document.querySelector('#backOne');
        backBtnOne.addEventListener('click', e => {
            e.preventDefault();
            AlcoholCalculator.backBtnOneClick();
        });

        const backBtnTwo = document.querySelector('#backTwo');
        backBtnTwo.addEventListener('click', e => {
            e.preventDefault();
            AlcoholCalculator.backBtnTwoClick();
        });

        calcElement.setAttribute('data-initialised', 'true');
    });

    // Return public API
    return {
        initAlcoholCalculator: initAlcoholCalculator
    };

})();

document.addEventListener('DOMContentLoaded', function () {
    alcoholUnit.initAlcoholCalculator();
});
